import { useContext, useMemo } from 'react';
import { useTheme } from 'styled-components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
// import { useQuery } from 'react-query';
// import * as api from '../../services/api';
import jobTypes from './mocks/jobTypes.json';

const useJobTypes = () => {
  const { t } = useContext(ConfigContext);
  const theme = useTheme();
  // const storeKey = ['jobTypes'];
  // const { isLoading, data } = useQuery(storeKey, api.fetchJobTypes);
  const isLoading = false;
  const data = jobTypes;

  const colors = useMemo(
    () =>
      [
        theme.colors.palette[4],
        theme.colors.palette[3],
        theme.colors.palette[5],
        theme.colors.palette[6]
      ].map(({ dark, light }) => ({ color: dark, background: light })),
    [theme.colors.palette]
  );

  const jobTypesOptions = useMemo(() => (data?.data || []).map(({ id, slug }) => ({ value: id, label: t(slug) })), [
    data?.data,
    t
  ]);

  const mappedJobTypes = useMemo(
    () =>
      jobTypesOptions.reduce(
        (prev, { value, label }, index) => ({ ...prev, [value]: { label, ...colors[index % colors.length] } }),
        {}
      ),
    [colors, jobTypesOptions]
  );

  return { isLoading, jobTypesOptions, mappedJobTypes };
};

export default useJobTypes;
